import { gql } from "@apollo/client";

import { myLensesPreviewMediaFragment } from "./myLensesPreviewMediaFragment";

export const lensFragment = gql`
    fragment Lens on MyLensesLens {
        id
        name
        iconUrl
        previewUrl
        tagsList
        spectaclesTags
        surfaceType
        description
        scanTriggersList
        lensAccountId {
            organizationId
            lensSpaceId
            userId
            profileId
            organizationAndAdAccountId {
                organizationId
                adAccountId
            }
        }
        lensCta {
            website {
                url
            }
            deeplink {
                uri
                appName
                iosAppId
                androidAppUrl
            }
            type
            text
        }
        visibility
        status
        distributionsList {
            destinationId
            destinationType
            status
        }
        updatedAt {
            nanos
            seconds
        }
        createdAt {
            nanos
            seconds
        }
        updatedBy
        qrCode {
            deeplink
            imagesList {
                format
                imageUrl
            }
        }
        primaryCategoryId
        secondaryCategoryId
        adAccountId
        organizationId
        unlockableId
        rejectionErrors {
            heading
            messagesList
            violatingComponentsList
            hasSubmissionErrors
        }
        digitalGoodsList {
            sku
            type
            consumableQuantity
            priceTier
            title
            description
            localizationsList {
                locale
                title
                description
            }
            status
            lensId
        }
        discoverability {
            tagsList
            description
            locationsList
            daysTimesHolidaysList
        }
        lensCreatorPayoutEligibility
        distributionRestrictionsList {
            restrictionType
            messagesList
        }
        previewMediaList {
            ...MyLensesPreviewMedia
        }
        sourceApplication
        disabledDestinationTypesList
        exclusiveLensStatus
        markedAsExclusiveAt {
            seconds
            nanos
        }
        isAIClip
        isGameUserProvided
    }
    ${myLensesPreviewMediaFragment}
`;
